import React from 'react'
import classnames from 'classnames'
import { List, Text } from 'src/Components'

import styles from './GemDetail.module.scss'

const Heading = props => (
  <Text
    className={styles.heading}
    align='center'
    weight='light'
    variant='neutralCool'
    variantCount='900'
    {...props}
  />
)

const ProConList = ({ className, ...restProps }) => (
  <List.ProConList
    className={classnames(className, styles.list)}
    {...restProps}
  />
)

const BulletedList = ({ className, ...restProps }) => (
  <List.Bulleted
    className={classnames(className, styles.list)}
    {...restProps}
  />
)

const Strong = props => (
  <Text
    weight='bold'
    element='span'
    variant='neutralCool'
    variantCount='900'
    {...props}
  />
)

const {
  Pro: UnstyledPro,
  Con: UnstyledCon,
  Info: UnstyledInfo,
} = List.ProConList

const LI =
  Component =>
  ({ className, ...restProps }) =>
    <Component className={classnames(styles.li, className)} {...restProps} />

const Pro = LI(UnstyledPro)
const Con = LI(UnstyledCon)
const Info = LI(UnstyledInfo)

export { BulletedList, ProConList, Pro, Con, Info, Heading, Strong }
